<div class="pr-social-media">
  <a *ngFor="let social of socialLinks; index as i;" [ngClass]="i? 'space' :'none'" [href]="social.href"
    target="_blank" [title]="social.title">
    <img *ngIf="social.icon === 'facebook'" [ngClass]="social.icon" src="./assets/icons/facebook.svg">
    <img *ngIf="social.icon ==='linkedin'" [ngClass]="social.icon" src="./assets/icons/linkedin.svg">
  </a>
</div>
